import { pascalToCamelCase } from "./stringUtility";

const states = {
    australianCapitalTerritory: "ACT",
    newSouthWales: "NSW",
    northernTerritory: "NT",
    queensland: "QLD",
    southAustralia: "SA",
    tasmania: "TAS",
    victoria: "VIC",
    westernAustralia: "WA",
    nz_Northland: "NZ-NTL",
    nz_Auckland: "NZ-AUK",
    nz_Waikato: "NZ-WKO",
    nz_BayOfPlenty: "NZ-BOP",
    nz_Gisborne: "NZ-GIS",
    nz_HawkesBay: "NZ-HKB",
    nz_Taranaki: "NZ-TKI",
    nz_Manawatu_Whanganui: "NZ-MWT",
    nz_Wellington: "NZ-WGN",
    nz_Tasman: "NZ-TAS",
    nz_Nelson: "NZ-NSN",
    nz_Marlborough: "NZ-MBH",
    nz_WestCoast: "NZ-WTC",
    nz_Canterbury: "NZ-CAN",
    nz_Otago: "NZ-OTA",
    nz_Southland: "NZ-STL",
    nz_northland: "NZ-NTL",
    nz_auckland: "NZ-AUK",
    nz_waikato: "NZ-WKO",
    nz_bayOfPlenty: "NZ-BOP",
    nz_gisborne: "NZ-GIS",
    nz_hawkesBay: "NZ-HKB",
    nz_taranaki: "NZ-TKI",
    nz_manawatu_Whanganui: "NZ-MWT",
    nz_wellington: "NZ-WGN",
    nz_tasman: "NZ-TAS",
    nz_nelson: "NZ-NSN",
    nz_marlborough: "NZ-MBH",
    nz_westCoast: "NZ-WTC",
    nz_canterbury: "NZ-CAN",
    nz_otago: "NZ-OTA",
    nz_southland: "NZ-STL"
};

const acronymToState = Object.fromEntries(
    Object.entries(states).map(([key, value]) => [value, key])
);

export function getStateAcronym(stateName) {
    let camelCaseState = pascalToCamelCase(stateName);
    return states[camelCaseState] || null;
}

export function getStateName(acronym) {
    return acronymToState[acronym] || null;
}

export function getStatesArray() {
    return Object.entries(states).map(([value, text]) => ({ value, text }));
}
